import { gsap } from "gsap";

/*
 * Central GSAP setup. All entrance timelines route through here so motion
 * stays consistent (one easing language) and reduced-motion is respected
 * in exactly one place.
 */

export const prefersReducedMotion = () =>
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

gsap.defaults({
    ease: "power3.out",
    duration: 0.55,
});

/*
 * Staggered entrance for a page. targets: array of {el(s), y?, delay?}.
 * Returns the timeline (or null when reduced motion is on) — caller kills it
 * on unmount. Elements stay interactive throughout (opacity/transform only).
 */
export function entrance(steps) {
    if (prefersReducedMotion()) return null;

    const tl = gsap.timeline();
    steps.forEach(({ targets, y = 18, stagger = 0.08, at }) => {
        const els = gsap.utils.toArray(targets).filter(Boolean);
        if (!els.length) return;
        tl.from(
            els,
            { y, opacity: 0, stagger, clearProps: "transform,opacity" },
            at !== undefined ? at : "<0.12"
        );
    });
    return tl;
}

export { gsap };
